import React from "react";
import { useField } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { updateDeploymentAttributes } from "actions";
import { UPDATE_DEPLOYMENT_LABELS } from "constants/actionTypes";
import { getCurrentSpeciesId } from "selectors";
import { getLabelsBySpecies } from "selectors/speciesAttributes";
import {
  QuickMultiOptionsWithSelect,
  LabelSelectFieldOption,
} from "components/Form/FormikControls";
import { LabelSelectorField } from "./LabelSelectorField";

interface SaleLotLabelSelectorFieldProps {
  name: string;
  label: string;
  tooltip?: string;
  disabled?: boolean;
  required?: boolean;
  deploymentId: number;
}

export const SaleLotLabelSelectorField = ({
  name,
  label,
  tooltip,
  disabled,
  required,
  deploymentId,
}: SaleLotLabelSelectorFieldProps) => {
  const dispatch = useDispatch();

  const handleUpdate = payload =>
    dispatch(updateDeploymentAttributes(UPDATE_DEPLOYMENT_LABELS, payload));

  const currentSpeciesId: number = useSelector(getCurrentSpeciesId);

  const labels: DeploymentLabel[] = useSelector(getLabelsBySpecies);

  const [{ value: labelsInUse = [] }] = useField(name);

  const options: LabelSelectFieldOption[] = labels
    .filter(
      l =>
        labelsInUse.includes(l.id) ||
        (l.deployment_id === deploymentId && l.quick_select && !l.deprecated),
    )
    .sort((a, b) => a.order - b.order)
    .map(option => ({
      label: option.name,
      value: option.id,
      isMasterLabel: !!option.masterLabel,
    }));

  const addLabel = valueLabel => {
    const payload = {
      order: labels.length,
      deployment_id: deploymentId,
      name: valueLabel,
      species_id: currentSpeciesId,
      is_used: true,
      id: uuidv4(),
      quick_select: true,
      is_manual_charge_label: false,
      deprecated: false,
    };
    handleUpdate([payload]);
  };

  return (
    <QuickMultiOptionsWithSelect
      name={name}
      label={label}
      tooltip={tooltip}
      required={required}
      disabled={disabled}
      options={options}
      maxQuickSelect={8}
      SelectComponent={LabelSelectorField}
      selectProps={{ addLabel }}
    />
  );
};
